<div class="container-fluid">
<section>
	<header>
		<h1>
			<span jhiTranslate="site-admin.title">Site Administration</span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
		</h1>
	</header>
	<nav>
		<ul class="nav nav-tabs">
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['users']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="site-admin.tabs.users"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['roles']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="site-admin.tabs.roles"></a>
			</li>
            <li class="nav-item pe-1">
                <a class="nav-link" [routerLink]="['oauth-clients']" [routerLinkActive]="['active']" queryParamsHandling="merge"
                   jhiTranslate="site-admin.tabs.oauth-clients"></a>
            </li>
		</ul>
	</nav>
	<div class="tab-content p-3">
		<router-outlet></router-outlet>
	</div>
</section>
</div>
